<template>
  <div class="row cheating-violation-info">
    <div class="col-xl-6 mt-3">
      <label>Lần vi phạm trong khóa</label>
      <div class="violation-value">{{ displayValue(info.cheat_count) }}</div>
    </div>
    <div class="col-xl-6 mt-3">
      <label>Hành vi vi phạm</label>
      <div class="violation-value violation-value--multiline">
        <template v-if="behaviors.length">
          <div v-for="(behavior, index) in behaviors" :key="index">{{ behavior }}</div>
        </template>
        <template v-else>Không có</template>
      </div>
    </div>
    <div class="col-xl-6 mt-3">
      <label>Chi tiết hành vi vi phạm</label>
      <div class="violation-value violation-value--multiline">{{ displayValue(info.cheat_description) }}</div>
    </div>
    <div class="col-xl-6 mt-3">
      <label>Bằng chứng vi phạm</label>
      <div class="violation-value violation-value--multiline">
        <a v-if="safeLink(info.cheat_evidence)" :href="safeLink(info.cheat_evidence)" target="_blank" rel="noopener noreferrer">{{ info.cheat_evidence }}</a>
        <span v-else>{{ displayValue(info.cheat_evidence) }}</span>
      </div>
    </div>
    <div class="col-xl-6 mt-3">
      <label>Record trao đổi, xử lý</label>
      <div class="violation-value violation-value--multiline">
        <a v-if="safeLink(info.cheat_info_process)" :href="safeLink(info.cheat_info_process)" target="_blank" rel="noopener noreferrer">{{ info.cheat_info_process }}</a>
        <span v-else>{{ displayValue(info.cheat_info_process) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheatingViolationInfo',
  props: {
    info: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    behaviors() {
      const value = this.info.cheat_reasons;
      if (Array.isArray(value)) {
        return value
          .map(item => typeof item === 'object' ? item.reason || item.name || item.label : item)
          .filter(item => item !== null && item !== undefined && String(item).trim());
      }
      return value !== null && value !== undefined && String(value).trim() ? [value] : [];
    }
  },
  methods: {
    displayValue(value) {
      return value !== null && value !== undefined && String(value).trim() ? value : 'Không có';
    },
    safeLink(value) {
      try {
        const url = new URL(value);
        return ['http:', 'https:'].includes(url.protocol) ? url.href : '';
      } catch (error) {
        return '';
      }
    }
  }
};
</script>

<style scoped>
.cheating-violation-info { margin-top: 4px; }
.violation-value { min-height: 40px; padding: 10px 15px; overflow-wrap: anywhere; color: #000; background: #fff; border: 1px solid #e4e7ed; border-radius: 4px; }
.violation-value--multiline { white-space: pre-wrap; }
</style>
